import { render, staticRenderFns } from "./ShadowSettings.vue?vue&type=template&id=6e6c1b1c&scoped=true"
import script from "./ShadowSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShadowSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShadowSettings.vue?vue&type=style&index=0&id=6e6c1b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c1b1c",
  null
  
)

export default component.exports